import type { RosterBooking } from '../../../../api/workshops';

import { CheckInRow } from './CheckInRow';

/** The bookings to check in, or a note when the search matches none. */
export function CheckInRowList({
  rows,
  pendingId,
  onToggle,
  onOpenStepper,
}: {
  rows: RosterBooking[];
  pendingId: string | undefined;
  onToggle: (b: RosterBooking, nextCount: number) => void;
  onOpenStepper: (b: RosterBooking) => void;
}) {
  if (rows.length === 0) {
    return (
      <div
        style={{
          fontSize: 13,
          color: 'var(--nb-subtle)',
          padding: '18px 4px',
          textAlign: 'center',
        }}
      >
        No matching guests
      </div>
    );
  }
  return (
    <div style={{ overflow: 'auto', display: 'flex', flexDirection: 'column', gap: 2, flex: 1 }}>
      {rows.map((b) => (
        <CheckInRow
          key={b.bookingId}
          booking={b}
          pending={pendingId === b.bookingId}
          onToggle={onToggle}
          onOpenStepper={onOpenStepper}
        />
      ))}
    </div>
  );
}
